import axios from 'axios';
import apiClient from './apiClient';
import type { LoginCredentials } from '../types';

export interface LoginResult {
  token: string;
  refreshToken: string;
  tokenType: string;
  expiresIn: number;
}

export interface LoginResponse {
  code: number | string;
  message: string;
  result: LoginResult;
}

export interface IntrospectResult {
  valid: boolean;
}

export interface IntrospectResponse {
  code: number | string;
  message?: string;
  result: IntrospectResult;
}

interface AuthenticationErrorBody {
  message?: string;
}

// Đăng nhập
export const login = async (credentials: LoginCredentials): Promise<LoginResponse> => {
  const response = await apiClient.post<LoginResponse>('/auth/login', credentials);
  return response.data;
};

// Đăng xuất
export const logout = async (token: string): Promise<void> => {
  await apiClient.post('/auth/logout', { token });
};

export const introspectToken = async (token: string): Promise<boolean> => {
  const response = await apiClient.post<IntrospectResponse>('/auth/introspect', { token });
  return response.data.result.valid;
};

export const refreshAuthentication = async (refreshToken: string): Promise<LoginResult> => {
  const response = await apiClient.post<LoginResponse>('/auth/refresh', { token: refreshToken });
  return response.data.result;
};

export const getAuthenticationErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (axios.isAxiosError<AuthenticationErrorBody>(error)) {
    if (error.response?.status === 401) {
      return 'Tên đăng nhập hoặc mật khẩu không đúng.';
    }
    return error.response?.data?.message?.trim() || fallback;
  }
  return error instanceof Error && error.message ? error.message : fallback;
};
